// DS: I109
// from GDrive
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const ArtStageArrowR: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="27"
      height="48"
      viewBox="0 0 27 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 27L3 48l-3-3 21-21L0 3l3-3 24 24-3 3z"
        fillRule="evenodd"
      />
    </svg>
  </IconWrap>
);
ArtStageArrowR.displayName = 'ArtStageArrowR';

export default ArtStageArrowR;
